// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import acceptanceTestEntity from './entities/acceptance-test.json';
import acceptanceTestMenu from '../pages/acceptance-test/menu.json';
import acceptanceTestFullForm from '../pages/acceptance-test/forms/full.json';
import acceptanceTestContextForm from '../pages/acceptance-test/forms/context.json';
import acceptanceTestMiniForm from '../pages/acceptance-test/forms/mini.json';
import acceptanceTestLookupForm from '../pages/acceptance-test/forms/lookup.json';
import acceptanceTestTableView from '../pages/acceptance-test/views/table.json';
import acceptanceTestCardsView from '../pages/acceptance-test/views/cards.json';
import acceptanceTestDashboardView from '../pages/acceptance-test/views/dashboard.json';

/** Тип запису «Приймальний тест» зі сторінками пакета: меню, форми та подання з pages/acceptance-test/. */
export const acceptanceTestDefinition: IRecordTypeDefinition = {
  ...acceptanceTestEntity,
  views: assembleViewSet({
      table: acceptanceTestTableView,
      cards: acceptanceTestCardsView,
      dashboard: acceptanceTestDashboardView,
  }),
  form: acceptanceTestFullForm,
  forms: { full: acceptanceTestFullForm, context: acceptanceTestContextForm, mini: acceptanceTestMiniForm, lookup: acceptanceTestLookupForm },
  menu: acceptanceTestMenu,
} as IRecordTypeDefinition;
